import React from "react";
import ReactAnimatedWeather from "react-animated-weather";
import { weatherMap } from "./utils/constants";

export default function ForecastPreview(props) {
  function hours() {
    let date = new Date(props.data.dt * 1000);
    let hours = date.getHours();
    return `${hours}:00`;
  }

  function temperature() {
    let temperature = Math.round(props.data.main.temp);
    return `${temperature}°C`;
  }
  return (
    <div className="weatherForecast row">
      <div className="col">
        {hours()}
        <ReactAnimatedWeather
          icon={weatherMap[props.data.weather[0].icon]}
          animated={true}
          size={64}
        />
        {temperature()}
      </div>
    </div>
  );
}
